import { FC } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { Slide, ToastContainer } from 'react-toastify'
import { ReactFlowProvider } from 'reactflow'

import AuthSocketWrapper from './socketContainers/AuthSocketWrapper'
import useInitialAuth from './hooks/useInitialAuth'

import { Props } from './types/common'

import 'react-toastify/dist/ReactToastify.css'
import 'reactflow/dist/style.css'
import 'shared/assets/styles/index.scss'
import 'shared/assets/styles/variables.scss'
import 'shared/assets/styles/fonts.scss'
import 'shared/assets/styles/animate.scss'
import 'shared/assets/styles/react-flow.scss'

const AppWrapper: FC<Props> = ({ children }) => {
  useInitialAuth()

  return (
    <ReactFlowProvider>
      <BrowserRouter>
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          pauseOnHover
          transition={Slide}
          theme="dark"
        />
        <AuthSocketWrapper>{children}</AuthSocketWrapper>
      </BrowserRouter>
    </ReactFlowProvider>
  )
}

export default AppWrapper
